var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PCNavbar',{attrs:{"selectIndex":"13"}}),_c('MobileNavBar',{attrs:{"currentActive":12}}),_c('esgEvaluation'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }